import { Building, Mails, Users } from "lucide-react";
import {
  OrganizationInfo,
  OrganizationInfoSkeleton,
} from "../OrganizationInfo";
import { Suspense, use } from "react";
import { TabsList, TabsTrigger } from "@facade/components/ui";

import { OrganizationSideMenuProps } from "./OrganizationSideMenu.types";
import { ViewOrganizationContext } from "../../contexts";

export const OrganizationSideMenu = ({
  onMembersIntent,
}: OrganizationSideMenuProps) => {
  const { id } = use(ViewOrganizationContext);

  return (
    <div className="flex flex-col w-72 gap-4">
      <div className="flex items-center gap-3">
        <Suspense fallback={<OrganizationInfoSkeleton />}>
          <OrganizationInfo organizationId={id} />
        </Suspense>
      </div>
      <TabsList className="w-full">
        <TabsTrigger value="general">
          <Building /> General
        </TabsTrigger>
        <TabsTrigger
          value="members"
          onMouseEnter={onMembersIntent}
          onFocus={onMembersIntent}
        >
          <Users />
          Members
        </TabsTrigger>
        <TabsTrigger value="invites">
          <Mails />
          Convites
        </TabsTrigger>
      </TabsList>
    </div>
  );
};
